module.exports = __webpack_public_path__ + "static/media/haute14A.ef1da441.jpg";